/* Home grid: every tab shows just the first row of products plus a "See all" button, to keep the page short.
   Men tab: the shared unisex hoodies open with the Men's photos (?for=men). */
(function () {
  var MAP = {
    'Women': ['/collections/all/women', 'See all Women’s'],
    'Men': ['/collections/all/men', 'See all Men’s'],
    'Hats': ['/collections/all/hats', 'See all Hats'],
    'Jewelry': ['/collections/all/jewelry', 'See all Jewelry'],
    'His & Hers': ['/collections/his-hers', 'See all Couples'],
    'Halloween': ['/collections/all/halloween', 'See all Halloween'],
    'Home & Decor': ['/collections/all/home-decor', 'See all Home & Decor']
  };
  var current = '';
  function apply(tag) {
    current = tag;
    var sec = document.getElementById('shop'); if (!sec) return;
    var grid = sec.querySelector('.grid'); if (!grid) return;
    var wrap = sec.querySelector('.see-all-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'see-all-wrap';
      wrap.style.cssText = 'text-align:center;margin-top:22px;';
      wrap.innerHTML = '<a class="btn btn-outline" href="#"></a>';
      grid.parentNode.insertBefore(wrap, grid.nextSibling);
    }
    /* unisex hoodies: open on the man's photos when browsing Men */
    grid.querySelectorAll('.card[data-img-men]').forEach(function (c) {
      c.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var base = a.dataset.base || a.getAttribute('href').split('?')[0];
        a.dataset.base = base;
        a.setAttribute('href', base + (tag === 'Men' ? '?for=men' : ''));
      });
    });
    var info = MAP[tag];
    if (!info) { wrap.style.display = 'none'; return; }
    var members = [];
    grid.querySelectorAll('.card').forEach(function (c) {
      var member = (c.dataset.tags || '').split('|').indexOf(tag) > -1;
      if (member) { c.style.display = ''; members.push(c); } else { c.style.display = 'none'; }
    });
    var shown = 0;
    if (members.length) {
      var top = members[0].offsetTop;
      members.forEach(function (c) {
        if (c.offsetTop - top > 8) c.style.display = 'none'; else shown++;
      });
    }
    var a = wrap.querySelector('a');
    a.href = info[0]; a.textContent = info[1] + ' →';
    wrap.style.display = members.length > shown ? '' : 'none';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.tab[data-tag]'); if (!t) return;
    apply(t.dataset.tag);
  });
  var timer;
  window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(function () { if (current) apply(current); }, 150); });
  function init() { var a = document.querySelector('#shop .tab.active'); apply(a ? a.dataset.tag : ''); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { if (current) apply(current); });
})();
